import { Card, CardContent, Typography, Link, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { TRUST_COPY } from '../constants/trustCopy';

/**
 * ParticipantStatus - Calm, minimal status display for joined participants
 *
 * Implements Story 2.7 requirements:
 * - Shows trust copy without metrics or gamification
 * - No admin surfaces, no participation counts
 * - No leaderboards, streaks, or engagement indicators
 * - Just the essentials: you're in, we'll be in touch
 *
 * This component is intentionally minimal — "nothing to do" is the correct UX.
 */
export const ParticipantStatus = () => {
  return (
    <Card sx={{ maxWidth: 480, mx: 'auto' }}>
      <CardContent>
        <Typography variant="h2" gutterBottom>
          {TRUST_COPY.PARTICIPANT_HOME_HEADING}
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph>
          {TRUST_COPY.PARTICIPANT_HOME_BODY}
        </Typography>

        <Typography variant="body2" color="text.secondary" paragraph>
          {TRUST_COPY.PARTICIPANT_HOME_NOTHING_TO_DO}
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Typography variant="body2" color="text.secondary">
            <Link
              component={RouterLink}
              to="/settings"
              sx={{ textDecoration: 'none', color: 'inherit', borderBottom: '1px solid' }}
            >
              Settings
            </Link>
            {' · '}
            <Link
              component={RouterLink}
              to="/transparency"
              sx={{ textDecoration: 'none', color: 'inherit', borderBottom: '1px solid' }}
            >
              {TRUST_COPY.TRANSPARENCY_LINK}
            </Link>
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
